import React from "react";

const AIScienceTechnology = () => {
  return (
    <div style={styles.page}>
      {/* Hero Section */}
      <div style={styles.hero}>
        <h1 style={styles.heroTitle}>Artificial Intelligence</h1>
        <p style={styles.heroSubtitle}>
          Transforming the World in the 21st Century
        </p>
      </div>

      {/* Article Card */}
      <div style={styles.container}>
        <section style={styles.section}>
          <h2 style={styles.heading}>Introduction</h2>
          <p style={styles.text}>
            Artificial Intelligence (AI) has emerged as one of the most powerful
            scientific and technological advancements of the modern era. From
            research laboratories to real-world applications, AI is reshaping
            economies, industries, and societies across the globe.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>AI in Everyday Life</h2>
          <p style={styles.text}>
            Voice assistants, recommendation systems, facial recognition, and
            smart home technologies rely on AI to deliver personalized and
            efficient experiences. These tools enhance convenience,
            accessibility, and productivity for people worldwide.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Revolutionizing Industries</h2>
          <p style={styles.text}>
            AI has transformed healthcare through early disease detection,
            medical imaging, and drug discovery. In finance, AI strengthens
            fraud detection and risk assessment. Manufacturing benefits from
            automation, predictive maintenance, and quality optimization.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Economic Growth & Workforce</h2>
          <p style={styles.text}>
            AI drives economic growth by improving efficiency and innovation.
            While automation may replace repetitive jobs, it also creates new
            opportunities in AI development, data science, and digital ethics,
            making reskilling essential.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Governance & Ethics</h2>
          <p style={styles.text}>
            Governments use AI in smart cities, public services, and
            cybersecurity. However, concerns about bias, privacy, and
            surveillance highlight the importance of transparent and
            responsible AI governance.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>The Future of AI</h2>
          <p style={styles.text}>
            Advances in generative AI, robotics, and autonomous systems promise
            deeper integration into human life. Responsible innovation will
            determine how effectively AI contributes to inclusive global
            progress.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>Conclusion</h2>
          <p style={styles.text}>
            Artificial Intelligence stands at the intersection of opportunity
            and responsibility. With ethical implementation and inclusive
            policies, AI has the potential to address global challenges and
            shape a sustainable future.
          </p>
        </section>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        © 2026 Science & Technology | AI Special Article
      </footer>
    </div>
  );
};

const styles = {
  page: {
    fontFamily: "'Inter', Arial, sans-serif",
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
    color: "#0f172a",
  },
  hero: {
    background: "linear-gradient(135deg, #2563eb, #1e40af)",
    color: "#fff",
    textAlign: "center",
    padding: "25px 20px",
  },
  heroTitle: {
    fontSize: "1.40rem",
    fontWeight: "600",
    marginBottom: "6px",
  },
  heroSubtitle: {
    fontSize: "1.0rem",
    opacity: 0.9,
  },
  container: {
    maxWidth: "900px",
    margin: "-40px auto 0",
    background: "#ffffff",
    borderRadius: "16px",
    padding: "40px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  },
  section: {
    marginBottom: "35px",
  },
  heading: {
    fontSize: "1.2rem",
    color: "#2563eb",
    borderLeft: "4px solid #2563eb",
    paddingLeft: "12px",
    marginBottom: "6px",
  },
  text: {
    fontSize: ".85rem",
    lineHeight: "1.5",
  },
  footer: {
    textAlign: "center",
    margin: "40px 0",
    fontSize: "0.9rem",
    color: "#64748b",
  },
};

export default AIScienceTechnology;
